import {
    BaseBoxShapeUtil,
    HTMLContainer,
    RecordProps,
    T,
    TLBaseShape,
    stopEventPropagation,
    TLResizeHandle,
} from 'tldraw'
import {TaskStatusType} from "../types/taskFlow.types";


type IMyEditableShape = TLBaseShape<
    'label-shape',
    {
        index: number,
        text: string,
        status: string,
        h: number,
        w: number
    }
>

export class LabelShapeUtil extends BaseBoxShapeUtil<IMyEditableShape> {
    static override type = 'label-shape' as const
    static override props: RecordProps<IMyEditableShape> = {
        index: T.number,
        text: T.string,
        status: T.string,
        w: T.number,
        h: T.number,
    }


    getDefaultProps(): IMyEditableShape['props'] {
        return {
            index: 1,
            text: '',
            status: '执行中',
            w: 100,
            h: 30,
        }
    }

    // 禁用调整大小功能
    override canResize = (_shape: IMyEditableShape) => {
        return false
    }

    // 隐藏调整大小的控制点
    override hideResizeHandles = (_shape: IMyEditableShape): boolean => {
        return true
    }

    // [2]
    component(shape: IMyEditableShape) {
        // [a]
        const isEditing = this.editor.getEditingShapeId() === shape.id

        return (
            <HTMLContainer
                id={shape.id}
                // [b]
                onPointerDown={isEditing ? stopEventPropagation : undefined}
                style={{
                    pointerEvents: isEditing ? 'all' : 'none',
                    backgroundColor: '#E3F0FF',
                    fontSize: 14,
                    borderRadius: 6,
                    color: '#444444',
                }}
            >
                <div style={{display: 'flex', alignItems: 'center', width: '100%', justifyContent: 'center',height: "100%"}}>
                    {shape.props.text}
                </div>
            </HTMLContainer>
        )
    }

    indicator(shape: IMyEditableShape) {
        // 返回固定大小的indicator
        return <rect width={shape.props.w} height={shape.props.h} />
    }
}